import axios from 'axios';
import callApi from './callApi';

export const fetchAssociatedTestCases = (testCycleId, projectId, searchValue, selectedTestSuite, status, latest, page = 1, pageSize = 20, lite) => {
  const url = `associations/${testCycleId}?search=${
    searchValue || ''
  }&suite=${selectedTestSuite || 'all'}&status=${status || ''}&latest=${latest || false}&page=${page}&pageSize=${pageSize}&lite=${lite || false}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const fetchAssociatedIssues = (entityId, projectId, forceRefresh=false) => {
  const url = `associations/jira-associations/${entityId}?forceRefresh=${forceRefresh}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const fetchFailedExecutionIssues = (entityId) => {
  const url = `associations/issues/${entityId}`;
  
  return callApi(url, {}, 'GET');
};

export const associateJiraIssue = (association) => {
  const url = `associations/jira-associations`;
  
  const body = {
    association
  }
  return callApi(url, {}, 'POST', body);
};

export const associateIssuesBulk = (associations, projectId) => {
  const url = `associations/jira-associations/bulkCreate`;
  const headers = {
    'X-Project-Id': projectId,
  };
  const body = {
    associations
  }
  return callApi(url, headers, 'POST', body);
};

export const updateIssuesPrioritiesBulk = (associations) => {
  const url = `associations/jira-associations/sync-priority`;
  
  const body = {
    associations
  }
  return callApi(url, {}, 'PUT', body);
};

export const syncJiraIssuesForProject = (projectId) => {
  const url = `associations/jira-associations/sync-issues`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const removeAssociatedIssue = (entityId, issueId) => {
  const url = `associations/jira-associations/${entityId}/${issueId}`;
  
  return callApi(url, {}, 'DELETE');
};

export const fetchAssociatedIssuesByTestCycle = (entityId, projectId, page, pageSize, forceRefresh=false) => {
  const url = `associations/jira-associations/test-cycle/${entityId}?forceRefresh=${forceRefresh}&page=${page}&pageSize=${pageSize}`;
  const headers = {
    'X-Project-Id': projectId,
  };
  return callApi(url, headers, 'GET');
};

export const exportTestcycleIssues = async (entityId, projectId) => {
  const url = `associations/jira-associations/export/${entityId}`;
  const headers = {
    'X-Project-Id': projectId,
  };

  return await callApi(url, headers, "GET", null, "blob");
};
